import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BookingRepository } from '@app/store';
import { first, map } from 'rxjs';

export const activeBookingGuard: CanActivateFn = () => {
  const bookingRepo = inject(BookingRepository);
  const router = inject(Router);

  return bookingRepo.activeBooking$.pipe(
    first(), // Ensure the observable completes after the first emission
    map((activeBooking) => {
      if (activeBooking) {
        return true;
      } else {
        return router.createUrlTree(['/explore']);
      }
    }),
  );
};
